import { styled } from 'next-yak';

// *** Components ***
export const Timestamp = styled.time``;
